<template>
    <div class="test-list">
        <div class="list">
            <el-table :data="userOrderList" style="width: 100%" :row-class-name="tableRowClassName" size="small">
                <el-table-column prop="id" label="订单编号"></el-table-column>
                <el-table-column prop="duration_days" label="订单有效时长(天)"></el-table-column>
                <el-table-column prop="start_time" label="订单有效期开始时间"></el-table-column>
                <el-table-column prop="end_time" label="订单有效期结束时间"></el-table-column>
                <el-table-column prop="is_active" label="订单是否有效"></el-table-column>
                <el-table-column prop="out_trade_no" label="订单支付编号"></el-table-column>
                <el-table-column prop="vip_level" label="vip等级"></el-table-column>
                <el-table-column prop="district" label="订单支付详情" width="180" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="primary" round size="small"
                            @click="getOrderDetails(scope.row.out_trade_no)">详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- <div class="block">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div> -->
        <el-dialog :visible.sync="dialogTableVisible" center destroy-on-close>
            <div class="dialog_title">订单详情</div>
            <div>
                <div class="flex_box">
                    <div>用户id号:</div>
                    <div class="el_from_span">{{ orderDetails.user_id }}</div>
                </div>
                <div class="flex_box">
                    <div>微信支付订单号:</div>
                    <div class="el_from_span">{{ orderDetails.transaction_id }}</div>
                </div>
                <div class="flex_box">
                    <div>appid:</div>
                    <div class="el_from_span">{{ orderDetails.appid }}</div>
                </div>
                <div class="flex_box">
                    <div>商户id:</div>
                    <div class="el_from_span">{{ orderDetails.mchid }}</div>
                </div>
                <div class="flex_box">
                    <div>交易类型:</div>
                    <div class="el_from_span">{{ orderDetails.trade_type }}</div>
                </div>
                <div class="flex_box">
                    <div>订单支付编号:</div>
                    <div class="el_from_span">{{ orderDetails.out_trade_no }}</div>
                </div>
                <div class="flex_box">
                    <div>交易状态:</div>
                    <div class="el_from_span">{{ orderDetails.trade_state }}</div>
                </div>
                <div class="flex_box">
                    <div>交易状态描述:</div>
                    <div class="el_from_span">{{ orderDetails.trade_state_desc }}</div>
                </div>
                <div class="flex_box">
                    <div>付款银行:</div>
                    <div class="el_from_span">{{ orderDetails.bank_type }}</div>
                </div>
                <div class="flex_box">
                    <div>附加数据:</div>
                    <div class="el_from_span">{{ orderDetails.attach }}</div>
                </div>
                <div class="flex_box">
                    <div>支付完成时间:</div>
                    <div class="el_from_span">{{ orderDetails.success_time }}</div>
                </div>
                <div class="flex_box">
                    <div>付款人信息</div>
                    <div class="el_from_span">{{ orderDetails.payer }}</div>
                </div>
                <div class="flex_box">
                    <div>订单总金额:</div>
                    <div class="el_from_span">{{ orderDetails.amount_total / 100 }}元</div>
                </div>
                <div class="flex_box">
                    <div>用户支付金额:</div>
                    <div class="el_from_span">{{ orderDetails.amount_payer_total / 100  }}元</div>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogTableVisible = false">关 闭</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            userOrderList: [],
            dialogTableVisible: false,
            orderDetails: {},
            formLabelWidth: '180px'
        }
    },
    created() {
        this.getUserOrder()
    },
    methods: {
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        getUserOrder() {
            this.$get(`/v1/all-subscriptions?id=${this.$route.query.user_id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data.data)
                    let orderList = res.data.data
                    orderList.map(item => {
                        if (item.is_active == true) {
                            item.is_active = '是'
                        } else if (item.is_active == false) {
                            item.is_active = '否'
                        } else {
                            item.is_active = ''
                        }
                        return { ...item }
                    })
                    console.log(orderList, '000000000000000000')
                    this.userOrderList = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        getOrderDetails(num) {
            this.$get(`/v1/order-info?out_trade_no=${num}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.dialogTableVisible = true
                    console.log(res.data.data)
                    this.orderDetails = res.data.data
                } else {
                    this.$msg(res.data.msg)
                }
            });
        }
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 200px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  
  </style>
<style scoped>
.flex_box{
    margin: 12px auto;
    display: flex;
    align-items: center;
}
.flex_box div:first-child{
    font-size: 20px;
    text-align: center;
    width: 30%;
    font-weight: 800;
    color: #000;
}
.flex_box div:last-child{
    font-size: 18px;
    text-align: center;
    color: #212121;
}
.dialog_title{
    margin-top: -30px;
    font-size: 30px;
    font-weight: 800;
    text-align: center;
    color: #000;
}
</style>


// WEBPACK FOOTER //
// src/pages/UserManage/userOrder.vue